import React, { createContext, useState } from 'react';

// Create the context
export const ActivityContext = createContext();

// Create the provider
export const ActivityProvider = ({ children }) => {
  const [activityModalOpen, setActivityModalOpen] = useState(false);

  return (
    <ActivityContext.Provider value={{ activityModalOpen, setActivityModalOpen }}>
      {children}
    </ActivityContext.Provider>
  );
};